"use client";

import React, { useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";

import { Form } from "@/components/Form";

import contactApiPostHandler from "@api/postContact";

import { resetForm } from "@/utils/formHelper";
import { contactUsValidation } from "@/utils/validators/contact-us";
import { ModalContext } from "@/contexts/ModalContext";
import { useApi } from "@/hooks/api/useApi";

import { getContactErrorModal, getContactSuccessModal } from "@/modals/ContactUs";

import { ModalHandlerProps } from "@/contexts/ModalContext/types";
import { amplitudeTrackEvent } from "@/services/AmplitudeService/AmplitudeService";

export const ContactFormContainer = ({ data }) => {
  const {
    request: postContactRequest,
    data: contactData,
    loading,
    error,
  } = useApi(contactApiPostHandler.postContact);

  const modalContext = React.useContext(ModalContext);

  const [formObject, setFormObject] = useState<
    { values: FieldValues; methods: UseFormReturn } | undefined
  >(undefined);

  const schema = contactUsValidation(data);

  const onSubmitForm = (values: FieldValues, methods: UseFormReturn) => {
    setFormObject({ values, methods });

    const formValues = methods.getValues();

    postContactRequest({
      fullName: formValues.fullName,
      email: formValues.email,
      subject: formValues.subject,
      question: formValues.query,
    });
  };

  React.useEffect(() => {
    amplitudeTrackEvent("view_landing_contact_us");
  }, []);

  React.useEffect(() => {
    if (formObject && contactData) {
      const successButton = () => {
        modalContext.handleModal();
        resetForm(formObject.values, formObject.methods);
      };
      const handleSuccessModalProps: ModalHandlerProps = {
        content: getContactSuccessModal({
          onConfirmButton: () => successButton(),
          data,
        }),
        hideCloseButton: true,
        onCancelCallback: successButton,
      };
      modalContext.handleModal(handleSuccessModalProps);
    }
  }, [contactData]);

  React.useEffect(() => {
    if (error) {
      const handleErrorModalProps: ModalHandlerProps = {
        content: getContactErrorModal({
          onConfirmButton: modalContext.handleModal,
          data,
        }),
        hideCloseButton: true,
      };
      modalContext.handleModal(handleErrorModalProps);
    }
  }, [error]);

  return (
    <Form
      fields={data?.formFields}
      onSubmit={(values, methods) => onSubmitForm(values, methods)}
      schema={schema}
      isLoading={loading}
    />
  );
};
